import {useEffect, useState} from "react";
import {getItems} from "../api/apiClient";

export const useItems = (page, itemCategoryId, itemPropertyValueIds) => {
    const [items, setItems] = useState([]);
    const [pagination, setPagination] = useState(null);
    const itemPropertyValueIdsKey = JSON.stringify(itemPropertyValueIds);

    useEffect(() => {
        const abortController = new AbortController();

        getItems({page, itemCategoryId, itemPropertyValueIds, signal : abortController.signal})
            .then((data) => {
                setItems(data.items);
                setPagination(data.pagination);
            })
            .catch((error) => console.log(error));

        return () => {
            abortController.abort();
        };
        // itemPropertyValueIdsKey is a stable string derived from itemPropertyValueIds,
        // used instead of the array itself since a new array reference is passed on every render.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, itemCategoryId, itemPropertyValueIdsKey]);

    return {items, pagination};
};
